import React from 'react';
import { Heading } from '@applyboard/crystal-ui';
import ProgramInfo from "./ProgramInfo";
var Blurb = function Blurb(_ref) {
  var program = _ref.program,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Heading, {
    level: 6,
    variant: "titleS"
  }, children), /*#__PURE__*/React.createElement(ProgramInfo, {
    program: program
  }));
};
export default Blurb;